var map = {
	"./Core/literals": "./src/Core/literals/index.ts",
	"./Core/literals/": "./src/Core/literals/index.ts",
	"./Core/literals/es/navMenu": "./src/Core/literals/es/navMenu.ts",
	"./Core/literals/es/navMenu.ts": "./src/Core/literals/es/navMenu.ts",
	"./Core/literals/index": "./src/Core/literals/index.ts",
	"./Core/literals/index.ts": "./src/Core/literals/index.ts",
	"./Modules/Auth/literals/en/forgotPassword": "./src/Modules/Auth/literals/en/forgotPassword.ts",
	"./Modules/Auth/literals/en/forgotPassword.ts": "./src/Modules/Auth/literals/en/forgotPassword.ts",
	"./Modules/Auth/literals/es/changePassword": "./src/Modules/Auth/literals/es/changePassword.ts",
	"./Modules/Auth/literals/es/changePassword.ts": "./src/Modules/Auth/literals/es/changePassword.ts",
	"./Modules/Auth/literals/es/confirmPassword": "./src/Modules/Auth/literals/es/confirmPassword.ts",
	"./Modules/Auth/literals/es/confirmPassword.ts": "./src/Modules/Auth/literals/es/confirmPassword.ts",
	"./Modules/Auth/literals/es/forgotPassword": "./src/Modules/Auth/literals/es/forgotPassword.ts",
	"./Modules/Auth/literals/es/forgotPassword.ts": "./src/Modules/Auth/literals/es/forgotPassword.ts",
	"./Modules/Auth/literals/es/signin": "./src/Modules/Auth/literals/es/signin.ts",
	"./Modules/Auth/literals/es/signin.ts": "./src/Modules/Auth/literals/es/signin.ts",
	"./Modules/Processes/literals/es/ProcessStates": "./src/Modules/Processes/literals/es/ProcessStates.ts",
	"./Modules/Processes/literals/es/ProcessStates.ts": "./src/Modules/Processes/literals/es/ProcessStates.ts",
	"./Modules/Uploader/literals/es/uploader": "./src/Modules/Uploader/literals/es/uploader.ts",
	"./Modules/Uploader/literals/es/uploader.ts": "./src/Modules/Uploader/literals/es/uploader.ts",
	"./Modules/User/literals/es/userConfiguration": "./src/Modules/User/literals/es/userConfiguration.ts",
	"./Modules/User/literals/es/userConfiguration.ts": "./src/Modules/User/literals/es/userConfiguration.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive literals";